import type {Base64ObjectInput, Question} from '@cp/model';
import {questionAdminCreateFromString} from '../../api/callable/question';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useCreateQuestionFromString() {
  const {
    fn: createQuestionFromString,
    loading,
    error,
  } = useFunctionWrap(
    async (
      moduleId: string,
      topic: string,
      questionJsonString: string,
      image?: Base64ObjectInput | null,
      skipFormat?: boolean,
      seedQuestionId?: string,
    ): Promise<Question> =>
      questionAdminCreateFromString({
        moduleId,
        topic,
        questionJsonString,
        image: image || undefined,
        skipFormat,
        seedQuestionId,
      }) as Promise<Question>,
  );

  return {
    createQuestionFromString,
    loading,
    error,
  };
}
